import BasePriceCard from './PriceCard';

export const PriceCard = BasePriceCard;
export type { PriceCardProps } from './PriceCard.interface';
